import React from "react";

type Props = {
    children: string | number,
    style: any,
}

const TableHeaderCell = ({children, ...restOfProps} : Props) => {
    return (<th {...restOfProps}>
        {children}
    </th>)
}

export default TableHeaderCell;